import { render, staticRenderFns } from "./SidebarItemLink.vue?vue&type=template&id=3af49782&"
import script from "./SidebarItemLink.vue?vue&type=script&lang=ts&"
export * from "./SidebarItemLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports